import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginMessageService {
  private $loginMessage = new BehaviorSubject<any>(null);

  getLoginMessage() {
    return this.$loginMessage.asObservable();
  }

  setLoginMessage(loginMessage: any) {
    this.$loginMessage.next(loginMessage);
  }
}